module.exports = __webpack_public_path__ + "static/media/005.8660022f.jpg";